import ContractDocument from "../ContractDocument";

export default class Deliverable extends ContractDocument {
  static type = "contractDocumentDeliverables";
}
